import { deleteDoc, setDoc } from 'firebase/firestore';
import { labels } from '../constants';
import { ModelCategoryFormData } from '../entities';
import { getModelCategoryRef } from '../infrastructures/firebase';
import { addErrorEventOnSentry } from '../infrastructures/sentry';
import { createUUID } from '../utils/create-unique-id';

/*
 * 一意のIDをクライアント側で作成しフォームからのPOSTデータに付与しつつ、
 * Firestore上のドキュメントIDにもしつつ、保存する
 */
const add = async (formData: ModelCategoryFormData) => {
  try {
    const id = createUUID();
    const ref = getModelCategoryRef(id);
    const formDataWithNewID = { ...formData, id };

    await setDoc(ref, formDataWithNewID);
  } catch (e) {
    addErrorEventOnSentry(e);
    throw new Error(labels.message.addFailure, { cause: e });
  }
};

const set = async (categoryId: string, formData: ModelCategoryFormData) => {
  try {
    const id = categoryId;
    const ref = getModelCategoryRef(id);
    const formDataWithNewID = { ...formData, id };

    await setDoc(ref, formDataWithNewID);
  } catch (e) {
    addErrorEventOnSentry(e);
    throw new Error(labels.message.updateFailure, { cause: e });
  }
};

const remove = async (categoryId: string) => {
  try {
    const ref = getModelCategoryRef(categoryId);

    await deleteDoc(ref);
  } catch (e) {
    addErrorEventOnSentry(e);
    throw new Error(labels.message.deleteFailure, { cause: e });
  }
};

export const ModelCategoryRepository = {
  add,
  set,
  remove,
};
